module.exports = __webpack_public_path__ + "img/prize2.d72605b5.png";